import { Version } from '@repo/toolkit/types'

import { CenterToJourney } from '../../lib/types/models/center-to-journey/center-to-journey'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterJourneys(id: number, version: Version = 'FULL') {
  return restApiClient
    .url(
      encodeNestedObject<{ version: Version }>(
        constructApiUrl(API.centers.getCenterJourneys.url, { id }),
        { version }
      )
    )
    .get<CenterToJourney[]>()
}
